import { ChangeEvent, useState } from "react";
import { AuthBottomBlock } from "../layout/AuthBottomBlock";
import AuthNavigationContainer from "../authNavigation/AuthNavigationContainer";
import { NavigateToSignIn } from "../authNavigation/NavigateToSignIn";
import { ForgetPasswordForm } from "./ForgetPasswordForm";

const ForgetPasswordView = () => {
  const [emailInput, setEmailInput] = useState("");

  const handleEmailChange = (e: ChangeEvent<HTMLInputElement>) => {
    setEmailInput(e.target.value);
  };

  return (
    <AuthBottomBlock>
      <div className="email-container no-line">
        <ForgetPasswordForm email={emailInput} onChange={handleEmailChange} />
        <AuthNavigationContainer>
          <NavigateToSignIn variant="back" />
        </AuthNavigationContainer>
      </div>
    </AuthBottomBlock>
  );
};

export default ForgetPasswordView;
